/**
 * Stripe PaymentMethod types that must use client-side confirmPayment +
 * /payment-return instead of server processStripeCheckout.
 * Allowlist so unknown future types stay on the legacy server-confirm path.
 */
const CLIENT_CONFIRM_PAYMENT_METHOD_TYPES = new Set(['upi']);

/**
 * Returns true when checkout should use stripe.confirmPayment + finalize
 * (non-card redirect methods). Gate on raw PaymentMethod.type — not wallet subtype.
 */
export const requiresClientConfirmPayment = (
  paymentMethodType: string | null | undefined,
): boolean => {
  if (!paymentMethodType) {
    return false;
  }
  return CLIENT_CONFIRM_PAYMENT_METHOD_TYPES.has(paymentMethodType);
};
